import { type ReactNode } from "react";

type SuggestionGradientCardProps = {
  /** Floating uppercase badge shown above the card top-left corner. */
  badgeLabel: string;
  children: ReactNode;
};

/**
 * Card with the brand conic-gradient border and a floating "SUGGESTION"-style
 * badge. Used to highlight AI-suggested content (e.g. a recommended executive
 * contact) inside the company side panel.
 */
export default function SuggestionGradientCard({
  badgeLabel,
  children,
}: SuggestionGradientCardProps) {
  return (
    <div className="relative">
      <div className="absolute top-0 left-3 z-10 -translate-y-1/2 rounded-md bg-[#393BB2] px-2 py-0.5 text-[10px] font-bold tracking-wider text-white">
        {badgeLabel}
      </div>
      <div className="relative overflow-hidden rounded-xl p-[2px]">
        <span className="absolute inset-[-1000%] bg-[conic-gradient(from_90deg_at_50%_50%,#E2CBFF_0%,#393BB2_50%,#E2CBFF_100%)]" />
        <div className="relative flex flex-col gap-3 rounded-[10px] bg-card p-4">
          {children}
        </div>
      </div>
    </div>
  );
}
